import { useEffect, useRef, useState } from 'react'
import { TICKER } from '../lib/landingData'

/**
 * A scoring run, in progress. Real Week 3 unit totals landing one at a time,
 * the way the settle job actually computes them. Doubles as the visual for
 * "we crunch this so you don't have to."
 */
export default function ScoreTicker() {
  // start part-filled so the panel is never an empty box on first paint
  const [n, setN] = useState(9)
  const [seen, setSeen] = useState(false)
  const wrap = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = wrap.current
    if (!el) return
    const io = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setSeen(true); io.disconnect() } },
      { threshold: 0.2 },
    )
    io.observe(el)
    return () => io.disconnect()
  }, [])

  useEffect(() => {
    if (!seen) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setN(TICKER.length)
      return
    }
    const id = setInterval(() => {
      setN((v) => (v >= TICKER.length ? v : v + 1))
    }, 120)
    return () => clearInterval(id)
  }, [seen])

  const rows = TICKER.slice(0, n)
  const done = n >= TICKER.length

  return (
    <div className="ticker" ref={wrap}>
      <div className="ticker-head">
        <span className="ticker-dot" data-done={done} />
        <span className="ticker-title">
          {done ? 'Week 3 scored' : 'Scoring Week 3'}
        </span>
        <span className="ticker-meta">{n} / 192 units</span>
      </div>
      <ol className="ticker-list">
        {rows.map(([label, pts], i) => (
          <li key={label} style={{ '--i': rows.length - i } as React.CSSProperties}>
            <span className="ticker-unit">{label}</span>
            <span className="ticker-bar">
              <span style={{ width: `${(pts / 55) * 100}%` }} />
            </span>
            <span className="ticker-pts">{pts.toFixed(1)}</span>
          </li>
        ))}
      </ol>
    </div>
  )
}
